<div fxLayout="column" class="reviews" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="100" class="container">
    <h2>Here’s what donors like you are saying about ReSupply</h2>
    <p>
      We deeply value each donor and strive to provide the highest level of care as you generously give back to your local charities and
      support local hauling groups.
    </p>

    <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
      @for (rl of reviews; track rl) {
        <div fxFlex="50">
          <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start center">
            @for (review of rl; track review) {
              <div class="review" fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <div fxLayout="row" fxLayoutAlign="start center" class="name" fxLayoutGap="10px">
                    <span fxLayoutAlign="center center">{{ review.name[0] }}</span>
                    <span>{{ review.name }}</span>
                  </div>
                  <star-rating [rating]="review.stars" [starType]="'svg'" [readOnly]="true"></star-rating>
                </div>
                <p [innerHTML]="review.review"></p>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  @if (review.icon) {
                    <mat-icon [svgIcon]="review.icon" />
                  }
                  @if (review.date) {
                    <span class="date">{{ review.date }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="buttons" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
      <button
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="10px"
        class="primary"
        (click)="goToPrimary(sectionType)"
      >
        <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
      <button fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="showVideo(sectionType)">
        <span fxFlex>About ReSupply</span>
        <mat-icon svgIcon="ss3-play"></mat-icon>
      </button>
    </div>
  </div>
</div>
